<template>
<div>
  <product-card :data="product" />
  <vx-card title="下单信息">
    <vx-form class="w-full" layout="v" label-align="top" v-slot="{handleSubmit}">
      <form-item label="订单号" label-align="none">
        {{form.orderid}}
      </form-item>
      <form-item label="订单标题" label-align="none">
        {{form.title}}
      </form-item>
      <form-item label="产品批号" label-align="none">
        <router-link :to="'/batchno/detail/' + batch.id" target="_blank">{{batch.batchNo}}</router-link>
      </form-item>
      <form-item label="二维码数量" label-align="none">
        {{form.number}}
      </form-item>
      <form-item v-if="$s.dict.priceMap.qrExpire[form.qrExpire]" label="二维码有效期" label-align="none">
        {{$s.dict.priceMap.qrExpire[form.qrExpire].name}}
      </form-item>
      <form-item label="是否需要印刷服务" label-align="none">
        {{form.printing ? '需要' : '不需要'}}
      </form-item>
      <div v-if="form.printing">
        <form-item label="标签尺寸" label-align="none">
          <span>{{sticky.width}}CM * {{sticky.height}}CM</span>
        </form-item>
        <form-item v-if="$s.dict.priceMap.material[form.material]" label="标签材质" label-align="none">
          <span>{{$s.dict.priceMap.material[form.material].name}}</span>
        </form-item>
        <form-item label="标签样式" label-align="none">
          {{style ? style.shape : '自定义'}}
          <div v-if="style">
            <a :href="style.picture" target="_blank"><img class="vs-image" :src="style.picture"></a>
          </div>
        </form-item>
        <form-item label="样式样本示例" label-align="none" v-if="order.styleID == -1">
          <a :href="order.sample" target="_blank"><img class="vs-image" :src="order.sample"></a>
        </form-item>
        <form-item label="下单备注" label-align="none">
          <vs-textarea v-model="form.comment"></vs-textarea>
        </form-item>

        <vs-row>
          <vs-col class="w-full sm:text-right sm:w-1/4 mb-5"><b>收货地址</b></vs-col>
        </vs-row>
        <form-item required label="联系人">
          <vs-input class="w-full" v-model="form.contactName" />
        </form-item>
        <form-item required label="联系电话">
          <vs-input class="w-full" v-model="form.contactPhone" />
        </form-item>
        <form-item required label="收货地址">
          <vs-input class="w-full" v-model="form.address" />
        </form-item>
      </div>

      <form-item label="价格">
        <div class="whitespace-no-wrap">
          ￥<vs-input class="inline-block" v-model="form.amount" />
        </div>
      </form-item>
      
      <form-item>
        <vs-button class="mr-3 mb-2" @click="handleSubmit(submitForm)">提交</vs-button>
        <vs-button class="mr-3 mb-2" color="warning" @click="setOrderSuccess">一键支付成功</vs-button>
        <vs-button color="primary" type="border" class="mb-2" to="/order/list">返回订单列表</vs-button>
      </form-item>
    </vx-form>
  </vx-card>
</div>
</template>
<script>
import ProductCard from '../batchNo/product-card'
export default {
  components: {
    ProductCard,
  },
  data() {
    return {
      sticky: {},
      product: {},
      order: {},
      style: {},
      batch: {},
      form: {
        contactName: '',
        contactPhone: '',
        address: '',
      },
    }
  },
  $computed: {
    // sticky: 'dict.price.sticky',
    qr: 'dict.price.qr',
  },
  async mounted() {
    const res = await this.$s.order.detail(this.$route.params.orderid)
    this.batch = res.batch
    this.product = res.product
    this.order = res.order
    this.sticky = res.sticky
    this.style = res.style
    this.form = {
      ...this.order,
      amount: (this.order.amount / 100).toFixed(2)
    }
  },
  methods: {
    async submitForm() {
      if (!parseInt(this.form.amount * 100)) {
        this.$notify({
          color: 'danger',
          title: '价格不能为0',
          text: '如果您要设置为0，请使用“一键支付成功”功能'
        })
        return
      }
      const data = {
        ...this.order,
        contactName: this.form.contactName,
        contactPhone: this.form.contactPhone,
        address: this.form.address,
        amount: parseInt(this.form.amount * 100),
      }

      const {order} = await this.$s.order.update(data)
      this.$notify({
        title: '订单修改成功',
        text: '您的修改订单操作将会以邮件形式通知用户'
      })
      this.$router.push('/order/list')
    },
    async setOrderSuccess() {
      this.$modal('adminPay', {order: this.order})
    }
  }
}
</script>